<dialog #dialog [id]="modalId" class="modal">
  <div class="modal-box vr-modal max-w-2xl bg-base-100">
    <form *ngIf="form && rule" [formGroup]="form" (ngSubmit)="submit()">
      <header class="flex items-center justify-between mb-4">
        <h2 class="text-lg font-semibold text-primary">
          Edit Location Rule:
          <code class="text-sm bg-base-200 px-1.5 py-0.5 rounded">{{ sourceValue() }}</code>
        </h2>
        <button
          type="button"
          (click)="close()"
          class="text-base-content/70 hover:text-base-content"
          aria-label="Close"
        >
          ×
        </button>
      </header>

      <!-- Read-only: allowed values -->
      <section class="mb-4 p-3 bg-base-200 border border-base-300 rounded">
        <h3 class="text-xs font-semibold text-primary uppercase tracking-wide mb-1">
          Allowed target values ({{ allowedValues().length }})
          <span class="text-base-content/70 normal-case font-normal">- managed by seed</span>
        </h3>
        <div class="max-h-32 overflow-y-auto text-xs text-base-content">
          <span *ngFor="let v of allowedValues(); let last = last">
            {{ v }}<span *ngIf="!last">, </span>
          </span>
        </div>
        <p class="mt-2 text-xs text-base-content/70 italic">
          To add or remove a value, edit the LOCATION_HIERARCHY dict in
          <code>_locations.py</code> and re-run <code>seed_validation_rules</code>.
        </p>
      </section>

      <!-- Editable fields -->
      <section class="space-y-3">
        <label class="block">
          <span class="text-sm font-medium text-primary-focus mb-1 block">Severity</span>
          <ng-select
            formControlName="severity"
            [items]="SEVERITY_OPTIONS"
            [clearable]="false"
          >
            <ng-template ng-label-tmp let-item="item">
              <span
                class="badge badge-sm"
                [class.badge-error]="item === 'ERROR'"
                [class.badge-warning]="item === 'WARNING'"
              >
                {{ item }}
              </span>
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              <span
                class="badge badge-sm"
                [class.badge-error]="item === 'ERROR'"
                [class.badge-warning]="item === 'WARNING'"
              >
                {{ item }}
              </span>
            </ng-template>
          </ng-select>
        </label>

        <label class="block">
          <span class="text-sm font-medium text-primary-focus mb-1 block">Sort Order</span>
          <input
            type="number"
            formControlName="sort_order"
            class="input input-bordered w-full h-10 min-h-10 px-3 text-sm rounded border-base-300 focus:outline-none focus:border-base-300"
          />
        </label>

        <label class="block">
          <span class="text-sm font-medium text-primary-focus mb-1 block">
            Message Template (optional)
          </span>
          <input
            type="text"
            formControlName="message_template"
            placeholder="Override the default error message"
            class="input input-bordered w-full h-10 min-h-10 px-3 text-sm rounded border-base-300 focus:outline-none focus:border-base-300"
          />
        </label>

        <label class="flex items-center gap-2">
          <input type="checkbox" formControlName="is_active" class="checkbox checkbox-sm" />
          <span class="text-sm font-medium text-primary-focus">Active</span>
        </label>
      </section>

      <footer class="flex justify-end gap-2 mt-6 pt-4 border-t border-base-300">
        <button
          type="button"
          (click)="close()"
          class="h-9 px-4 border border-base-300 rounded text-sm text-dark font-medium hover:bg-base-200 transition-colors"
        >
          Cancel
        </button>
        <button
          type="submit"
          [disabled]="form.invalid"
          class="h-9 px-6 border border-base-300 rounded text-sm text-dark font-medium hover:bg-info hover:text-white transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Save
        </button>
      </footer>
    </form>
  </div>
  <form method="dialog" class="modal-backdrop">
    <button (click)="close()">close</button>
  </form>
</dialog>
